import { Flex } from 'components/base/layout-components';
import { useDispatch } from 'react-redux';
import { toggleSnackBar } from 'state/callers';
import Text from 'components/base/Text';

const useToast = () => {
  const dispatch = useDispatch();

  const trigger = ({
    message,
    variant = 'success',
    moreInfo = null,
    actions = [],
    autoHideDuration = null,
    isOpen = undefined
  }) => {
    const text = moreInfo ? (
      <Flex direction='column'>
        <Text size='large' color='white'>
          {message}
        </Text>
        <Text size='large' color='white'>
          {moreInfo}
        </Text>
      </Flex>
    ) : (
      <Text size='large' color='white'>
        {message}
      </Text>
    );
    const toastPayload = {
      message: text,
      variant,
      actions,
      autoHideDuration,
      isOpen
    };

    toggleSnackBar(toastPayload)(dispatch);
  };
  return trigger;
};

export default useToast;
